import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";
import { useCompanyIdFromUrl } from "@/hooks/companies/useCompanyIdFromUrl";
const useSubscriptionPlans = () => {
  const companyId = useCompanyIdFromUrl();

  return useQuery({
    enabled: !!companyId,
    queryKey: ["subscriptionPlans", companyId],
    queryFn: () => {
      return apiClient.get(`subscriptions/plans`, {
        params: {
          companyId,
        },
      });
    },
  });
};

export { useSubscriptionPlans };
